<template>
  <div class="v-tabs">
    <template v-for="tab in tabs">
      <v-anchor v-if="tab.id" :id="tab.id" :key="`v-anchor-${tab.id}`" />
    </template>
    <div :class="['v-tabs__titles', overflow && 'v-tabs__titles--overflow']">
      <div class="v-tabs__titles__wrapper" ref="titles" role="tablist">
        <component
          v-for="(tab, index) in tabs"
          v-bind:is="tab.isLink ? 'a' : 'div'"
          v-bind="tab.$attrs"
          v-bind:key="'tab-' + index"
          :class="['v-tabs__title', { 'v-tabs__title--active': tab.isActive }]"
          :role="tab.isLink ? 'presentation' : 'tab'"
          :tabindex="tab.isLink ? null : tab.isActive ? '0' : '-1'"
          :aria-selected="tab.isLink ? null : tab.isActive.toString()"
          :aria-controls="tab.isLink ? null : `tabpanel-${tab._uid}`"
          :id="tab.isLink ? null : `tab-${tab._uid}`"
          @click="!tab.isLink && selectTab(index)"
          @keydown.native="!tab.isLink && onTabKeydown($event, index)"
          @keydown="!tab.isLink && onTabKeydown($event, index)"
          >{{ tab.title }}</component
        >
      </div>
    </div>
    <div class="v-tabs__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [],
      overflow: false
    };
  },
  methods: {
    selectTab(activeIndex) {
      this.tabs.forEach((tab, index) => {
        tab.isActive = activeIndex === index;
      });
      this.$emit("change", {
        name: this.tabs[activeIndex].title,
        index: activeIndex
      });
      this.setUrlHash(this.tabs[activeIndex].id);
    },
    setUrlHash(tabId) {
      if (!tabId) return;
      const location = window.location.href.split("#")[0];
      window.history.replaceState(null, null, `${location}#${tabId}`);
    },
    setActiveTab() {
      // Find the first active tab
      const activeTab = this.tabs.find(tab => tab.isActive);

      // Make sure only that tab is active
      this.tabs.forEach((tab, index) => {
        tab.isActive = tab === activeTab;
      });

      // Fall back to the first tab
      if (!activeTab && this.tabs.length > 0) {
        this.tabs[0].isActive = true;
      }
    },
    detectOverflow() {
      const titles = this.$refs.titles;
      if (titles.scrollWidth > titles.offsetWidth) {
        this.overflow = true;
      }
    },
    onTabKeydown(event, index) {
      const nonLinkTabs = this.tabs
        .map((tab, i) => ({ tab, i }))
        .filter(t => !t.tab.isLink);
      const currentPos = nonLinkTabs.findIndex(t => t.i === index);
      let newPos = -1;

      if (event.key === "ArrowRight" || event.key === "ArrowDown") {
        event.preventDefault();
        newPos = (currentPos + 1) % nonLinkTabs.length;
      } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
        event.preventDefault();
        newPos = (currentPos - 1 + nonLinkTabs.length) % nonLinkTabs.length;
      } else if (event.key === "Home") {
        event.preventDefault();
        newPos = 0;
      } else if (event.key === "End") {
        event.preventDefault();
        newPos = nonLinkTabs.length - 1;
      } else if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.selectTab(index);
        return;
      }

      if (newPos >= 0) {
        this.selectTab(nonLinkTabs[newPos].i);
        this.$nextTick(() => {
          const tabEl = this.$refs.titles.querySelectorAll("[role=tab]")[
            newPos
          ];
          if (tabEl) tabEl.focus();
        });
      }
    }
  },
  mounted() {
    this.tabs = this.$children;

    this.tabs = this.tabs.map(tab => {
      tab.isLink = !!tab.$attrs.href;
      return tab;
    });

    this.setActiveTab();
    this.$nextTick(this.detectOverflow);
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";
@import "./v-tabs.scss";
</style>
